import ReactDOM from "react-dom/client";
import App from "./components/App";
import UserService from "./services/UserService";
import HttpService from "./services/HttpService";

// Dynamic theme loading based on subdomain
const loadThemeAndRender = async () => {
  let theme;
  
  try {
    const subdomain = window.subdomain;
    const themeModule = await import(`./theme/${subdomain}`);
    theme = themeModule.getTheme();
  } catch (error) {
    // Fallback to default theme
    const defaultTheme = await import('./theme/theme.js');
    theme = defaultTheme.default;
  }
  
  // Common render logic
  const renderApp = () => ReactDOM.createRoot(document.getElementById('app')).render(<App theme={theme} />);
  
  UserService.initKeycloak(renderApp);
  HttpService.configure();
};

loadThemeAndRender();
